export const inquiryHeaderOptions = [
  { label: 'Add Inquiry', value: 'Add Inquiry', callback: 'onClickAdd' }
];

export const ellipsisCrudOptions = [
  { label: 'Update', value: 'edit', callback: 'onRowEdit' },
  { label: 'Delete', value: 'delete', callback: 'onRowDelete' }
];
